export default __webpack_public_path__ + "static/media/NunitoSans-ExtraBold.82529e41.woff";